var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-h5 font-weight-black text-uppercase d-flex align-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"large":"","color":"primary"},domProps:{"textContent":_vm._s(_vm.menu_info.icon)}}),_vm._v(" "+_vm._s(_vm.menu_info.title_en)+" ")],1),_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }